import { SearchType } from '@mews-commander/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { preselectSearchResult } from '../../search';
import { NEW_RESERVATION_SCREEN_EVENT_CATEGORY } from '../constants';
import {
    changeBookerId,
    changeCustomerId,
    changePartnerCompanyId,
    changeReservationGroupId,
    changeTravelAgencyId,
} from './options';

type ChangeAction = (value: string | null, scope: string) => CommanderThunkAction;

const createSearchResultPreselect =
    (scopeName: string, searchType: SearchType, changeAction: ChangeAction) =>
    ({ id, scope, serviceId }: { id: string; scope: string; serviceId?: string }): CommanderThunkAction =>
    (dispatch, getState, { loggerService }) => {
        const serviceScope = serviceId ? `-${serviceId}` : '';
        const optionalParams = serviceId ? { serviceIds: [serviceId] } : {};
        const searchScope = `${scopeName}-${scope}${serviceScope}`;

        dispatch(preselectSearchResult({ searchTypes: [searchType], id, optionalParams }, searchScope))
            .then(() => {
                dispatch(changeAction(id, scope));
            })
            .catch(() => {
                loggerService.log(NEW_RESERVATION_SCREEN_EVENT_CATEGORY, 'search-preselect-failed', {
                    searchType,
                    serviceId,
                });
            });
    };

export const preselectCustomer = createSearchResultPreselect('customerSearch', SearchType.Customer, changeCustomerId);
export const preselectBooker = createSearchResultPreselect('bookerSearch', SearchType.Customer, changeBookerId);
export const preselectPartnerCompany = createSearchResultPreselect(
    'companySearch',
    SearchType.Company,
    changePartnerCompanyId
);
export const preselectTravelAgency = createSearchResultPreselect(
    'travelAgencySearch',
    SearchType.TravelAgency,
    changeTravelAgencyId
);
export const preselectReservationGroup = createSearchResultPreselect(
    'reservationGroupSearch',
    SearchType.ReservationGroup,
    changeReservationGroupId
);
